<template>
  <div :class="themeClasses.pageContainer" class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h2 :class="themeClasses.headingText" class="mb-0">Roles y Permisos</h2>
        <p :class="themeClasses.mutedText">Gestión de roles y permisos de usuarios</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div :class="themeClasses.card" class="card">
          <div :class="themeClasses.cardBody" class="card-body">
            <h5 :class="themeClasses.cardTitle" class="card-title">Roles y Permisos de Usuario</h5>
            <p :class="themeClasses.cardText" class="card-text">Panel de gestión de roles y asignación de permisos.</p>
            <div :class="themeClasses.alertInfo" class="alert alert-info">
              <i class="fas fa-info-circle me-2"></i>
              Este módulo está en desarrollo. Pronto incluirá la gestión completa de roles.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'RolesPermisos',
  mixins: [themeMixin]
}
</script>

<style>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
